export const exportToJson = (objectData: any) => {
  let filename = 'my-profile.json';
  let contentType = 'application/json;charset=utf-8;';
  const nav = (window.navigator as any);
  if (nav && nav.msSaveOrOpenBlob) {
    let blob = new Blob(
      [decodeURIComponent(encodeURI(JSON.stringify(objectData)))],
      { type: contentType }
    );
    nav.msSaveOrOpenBlob(blob, filename);
  } else {
    let a = document.createElement('a');
    a.download = filename;
    a.href =
      'data:' +
      contentType +
      ',' +
      encodeURIComponent(JSON.stringify(objectData));
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
